import styled from 'styled-components';
import colors from '../../../../includes/colors';

export const Title = styled.h2`
  color: ${colors.black};
  line-height: 2.5rem;
  font-weight: 300;
  font-size: 1.0625rem;
  @media (min-width: 576px) {
    font-size: 1.25rem;
  }
`;

export const ClearSearch = styled.button`
  color: ${colors.darkBlue};
  font-weight: 300;
  line-height: 1rem;
  font-size: 0.875rem;
  display: block;
  background-color: transparent;
  border: none;
  @media (min-width: 480px) {
    margin-left: 30px;
    display: inline-block;
    font-size: 1rem;
  }
`;
